import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Accordion, { AccordionItem } from '../../@base/Accordion';
import Button from '../../@base/Button';
import Checkbox from '../../@base/Checkbox';
import Datatable from '../../@base/DataTable';
import {
  getParameter, preparingInput, onValidHandler, handleInputValid,
} from '../Commons';
import { showRemoveConfirmation } from '../../WatsonComponents/Commons';
import QuestionAnswerDetails from './QuestionAnswerDetails';

import styles from '../SharedStyle.module.css';
import intentStyle from '../../WatsonComponents/Itents/Intent.module.css';
import Input from '../../@base/Input';

import WordlistsConfiguration from './WordlistsConfiguration';

const FAQComponent = (props) => {
  if (!props.component.parameters) return null;

  const [inputValid, setInputValid] = useState({});
  const [idxDetailedQuestionAndAnswer, setIdxDetailedQuestionAndAnswer] = useState(null);
  const [qaToDelete, setQAToDelete] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const parameterList = props.component.parameters;
  const documentsParam = getParameter(parameterList, 'faq.search.documents');
  documentsParam.value = documentsParam.value ? documentsParam.value : '';

  const fuzziness = getParameter(parameterList, 'faq.search.fuzziness');
  const maxResults = getParameter(parameterList, 'faq.search.maxResults');
  const disambiguationTitle = getParameter(parameterList, 'faq.search.disambiguationTitle');
  const disambiguationTreshold = getParameter(parameterList, 'faq.search.disambiguationTreshold');
  const stopWords = getParameter(parameterList, 'faq.search.stopwords');
  const keywords = getParameter(parameterList, 'faq.search.keywords');

  const [documentsObject, setDocumentsObject] = useState(JSON.parse(documentsParam.value));

  const handleUpdateQuestion = (questions) => {
    documentsObject.documents[idxDetailedQuestionAndAnswer].questions = questions;
    setDocumentsObject({ ...documentsObject });
    props.updateParameter({
      ...documentsParam,
      value: JSON.stringify(documentsObject),
    });
  };

  const handleUpdateAnswer = (answer) => {
    documentsObject.documents[idxDetailedQuestionAndAnswer].answer = answer;
    setDocumentsObject({ ...documentsObject });
    props.updateParameter({
      ...documentsParam,
      value: JSON.stringify(documentsObject),
    });
  };

  const detailing = (idxQuestion) => {
    setIdxDetailedQuestionAndAnswer(idxQuestion);
  };

  const handleAddQuestionAnswer = () => {
    const updatedDocumentsObject = { ...documentsObject };
    updatedDocumentsObject.documents.push(
      {
        questions: [''],
        answers: [{
          contents: [
            {
              type: 'TEXT',
              text: '',
            },
          ],
        }],
      },
    );
    setDocumentsObject(updatedDocumentsObject);
    setIdxDetailedQuestionAndAnswer(updatedDocumentsObject.documents.length - 1);
  };

  const deleteQAHandler = (qas) => {
    const qaToRemove = [].concat(qas);
    if (qaToRemove.length > 0) setQAToDelete(qaToRemove);
  };

  const removeConfirmation = (qaIndexs) => {
    const updatedDocumentsObject = { ...documentsObject };
    updatedDocumentsObject
      .documents = updatedDocumentsObject
        .documents.filter((_, idx) => !qaIndexs.includes((idx + 1).toString()));

    props.updateParameter({
      ...documentsParam,
      value: JSON.stringify(updatedDocumentsObject),
    });

    setDocumentsObject(updatedDocumentsObject);
    setQAToDelete([]);
  };

  const handleOnChangeSearch = (e) => {

  };

  useEffect(() => {
    const updatedDocumentsObject = { ...documentsObject };
    const terms = searchValue.toLowerCase().split(' ').filter((t) => t.trim() !== '');
    for (const document of updatedDocumentsObject.documents) {
      if (document.questions.some((doc) => doc.toLowerCase().includes(terms))) {
        document.hidden = false;
      } else {
        document.hidden = true;
      }
    }

    setDocumentsObject(updatedDocumentsObject);
  }, [searchValue]);

  useEffect(() => {
    handleInputValid(inputValid, props);
  }, [inputValid]);

  useEffect(() => {
    const helperContent = (
      <div>
        {ReactHtmlParser(`${props.component.description}`)}
      </div>
    );
    props.setHelperContent(<div>{helperContent}</div>);
  }, []);

  return (
    <>
      {showRemoveConfirmation(
        qaToDelete,
        removeConfirmation,
        setQAToDelete,
      )}

      <Accordion>
        <AccordionItem active title="Perguntas e Resposta">
          <div>Perguntas e Respostas</div>
          <div className={styles.ComponentSubList}>

            {documentsObject.documents.length === 0 ? (
              <div style={{ margin: 'auto', width: 'fit-content' }}>
                <Button
                  primary
                  small
                  onClick={handleAddQuestionAnswer}
                >
                  <small>Adicionar pergunta e resposta</small>
                </Button>
              </div>
            ) : null}
            {idxDetailedQuestionAndAnswer !== null
              ? (
                <QuestionAnswerDetails
                  updateQuestion={handleUpdateQuestion}
                  updateAnswer={handleUpdateAnswer}
                  detail={documentsObject.documents[idxDetailedQuestionAndAnswer]}
                  handleBack={() => setIdxDetailedQuestionAndAnswer(null)}
                />
              ) : null}
            {idxDetailedQuestionAndAnswer == null && documentsObject.documents.length > 0
              ? (
                <Datatable
                  classes={`${intentStyle.Datatable} ${styles.ScrollDatable}`}
                  actionsItems={
                    [<div style={{ marginLeft: -16 }}>
                      <Input
                        value={searchValue}
                        inline
                        label={<i className="fa fa-search text-primary" aria-hidden="true" />}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>,
                      <Button
                        primary
                        small
                        classes={intentStyle.Button}
                        onClick={handleAddQuestionAnswer}
                      >
                        <small>Adicionar</small>
                      </Button>]
                  }
                  deleteRows={deleteQAHandler}
                >
                  <table>
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: 60 }}>
                          <Checkbox id="intent_check_all" />
                        </th>
                        <th scope="col">
                          Pergunta(s)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentsObject.documents.map((document, idx) => {
                        if (document.hidden !== undefined && document.hidden) {
                          return null;
                        }
                        return (
                          <tr>
                            <td>
                              <div style={{ paddingTop: 10 }}>
                                <Checkbox id={idx + 1} />
                              </div>
                            </td>
                            <td onClick={() => detailing(idx)}>
                              {document.questions[0]}
                              {document.questions.length > 1 ? (
                                <span className="text-primary">
                                  {' '}
                                  (+
                                  {document.questions.length - 1}
                                  )
                                </span>
                              ) : null}

                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Datatable>
              )
              : null}

          </div>
        </AccordionItem>
        <AccordionItem>
          <div>Configurações</div>
          <div className={styles.ComponentSubList} style={{ textAlign: 'left' }}>
            <div className="item-list">
              <div className="row">
                {preparingInput(<Input
                  label="Tolerância da busca Fuzzy:"
                  labelWidth={215}
                  width={80}
                  inline
                  mandatory
                  title={fuzziness.parameter.hint}
                />, fuzziness, props, onValidHandler(setInputValid, fuzziness))}
              </div>
              <div />
            </div>
            <div className="item-list">
              <div className="row">
                {preparingInput(<Input
                  label="Tolerância da desambiguação (%):"
                  labelWidth={215}
                  width={80}
                  number
                  percent
                  inline
                  mandatory
                  title={disambiguationTreshold.parameter.hint}
                />, disambiguationTreshold, props,
                onValidHandler(setInputValid, disambiguationTreshold))}
              </div>
              <div />
            </div>
            <div className="item-list">
              <div className="row">
                {preparingInput(<Input
                  label="Quantidade máxima de sugestões:"
                  labelWidth={215}
                  width={80}
                  inline
                  number
                  mandatory
                  title={maxResults.parameter.hint}
                />, maxResults, props, onValidHandler(setInputValid, maxResults))}
              </div>
              <div />
            </div>
            <div className="item-list">
              <div className="row">
                {preparingInput(<Input
                  label="Título dos resultados sugeridos:"
                  labelWidth={215}
                  width={250}
                  inline
                  mandatory
                  title={disambiguationTitle.parameter.hint}
                />, disambiguationTitle, props, onValidHandler(setInputValid, disambiguationTitle))}
              </div>
              <div />
            </div>

            <WordlistsConfiguration
              parameter={stopWords}
              updateParameter={props.updateParameter}
              name="Stopwords"
            />
            <WordlistsConfiguration
              parameter={keywords}
              updateParameter={props.updateParameter}
              name="Keywords"
            />
          </div>

        </AccordionItem>
        {props.localizationAccordionItem || null}
      </Accordion>
    </>
  );
};

export default FAQComponent;
